import Choices from 'choices.js';
class ComponentSearchBar {
  constructor() {
    this._init();
  }

  _init() {
    const search_btn = document.getElementById('search_btn');
    const search_btn_text = document.getElementById('search_btn-text');
    const data_clear_btn = document.querySelector('[data-clear-input]');
    const search_input = document.querySelector(
      '[data-search-input]'
    ) as HTMLInputElement;

    if (search_input) {
      search_input.addEventListener('input', function () {
        if (data_clear_btn) {
          if (search_input.value.length > 0) {
            data_clear_btn.classList.remove('is-active');
          } else {
            data_clear_btn.classList.add('is-active');
          }
        }
      });
    }
    if (data_clear_btn) {
      data_clear_btn.addEventListener('click', function () {
        const search_input = document.querySelector(
          '[data-search-input]'
        ) as HTMLInputElement;
        if (search_input) {
          search_input.value = '';
          data_clear_btn.classList.add('is-active');
        }
      });
    }

    const selects = document.querySelectorAll('.search-bar__select-input') as NodeListOf<HTMLSelectElement>;
    if (selects) {
      selects.forEach(select => {
        new Choices(select, {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: ''
        });
      })
    }



    if (search_btn) {
      search_btn.addEventListener(
        'mouseenter',
        function () {
          if (search_btn_text) {
            search_btn_text.innerText = 'Rechercher';
          }
        },
        false
      );

      search_btn.addEventListener(
        'mouseleave',
        function () {
          if (search_btn_text) {
            search_btn_text.innerText = "C'est parti !";
          }
        },
        false
      );
    }
  }
}

export const componentSearchbar = new ComponentSearchBar();
